// Admin audit log query (server-side pagination, action + period filters).
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import {
  getAdminAuditQueryKey,
  listAdminAuditLog,
  type AdminAuditFilters,
} from '../api/admin.client.js';

export function useAdminAuditLog(filters: AdminAuditFilters) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminAuditQueryKey(filters),
    queryFn: () => listAdminAuditLog(filters),
    enabled: isPlatformAdmin,
    placeholderData: keepPreviousData,
  });
}
